import logo from './logo.svg';
import './App.css';
import Home from './pages/Home';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Subscriptions from './pages/Subscriptions';
import Tutorial from './pages/Tutorial';
import Login from './pages/Login';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Profile from './pages/Profile';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import ContactUs from './pages/ContactUs';
import { LanguageProvider } from './LanguageContext';
import Community from './pages/Community';
import Safety from './pages/Safety';
import { ToastContainer } from "react-toastify"; 
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import About from './pages/About';

function App() {
  return (
    <>
    <ToastContainer />
    <LanguageProvider> 
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/subscriptions" element={<Subscriptions />} /> */}
        <Route path="/subscription-success" element={<SubscriptionSuccess/>} />
        {/* <Route path="/tutorial" element={<Tutorial />} /> */}
        {/* <Route path="/login" element={<Login/>} /> */}
        <Route path="/profile" element={<Profile/>} />
        <Route path="/privacy-policy" element={<Privacy/>} />
        <Route path="/terms-and-conditions" element={<Terms/>} />
        <Route path="/contact-us" element={<ContactUs/>} />
        <Route path="/community" element={<Community/>} />
        <Route path="/safety" element={<Safety/>} />
        <Route path="/about" element={<About/>} />

        
      </Routes>
      <Footer/>
    </Router>
    </LanguageProvider>
  </>
  );
}

export default App;